/**
 * Presentation Layer - App Providers
 * Combines all providers for the application
 */

"use client";

import { type PropsWithChildren } from "react";
import { NextIntlClientProvider } from "next-intl";
import { siteConfig } from "@/config/site";
import { ThemeProvider } from "./theme-provider";
import { QueryProvider } from "./query-provider";
import { ReduxProvider } from "./redux-provider";
import { AuthGuard } from "./auth-guard-provider";

interface AppProvidersProps extends PropsWithChildren {
  messages: Record<string, Record<string, string>>;
  locale: string;
}

export function AppProviders({
  children,
  messages,
  locale,
}: AppProvidersProps) {
  return (
    <NextIntlClientProvider
      messages={messages}
      locale={locale}
      timeZone={siteConfig.defaultTimeZone}
    >
      <ReduxProvider>
        <ThemeProvider>
          <QueryProvider>
            <AuthGuard>{children}</AuthGuard>
          </QueryProvider>
        </ThemeProvider>
      </ReduxProvider>
    </NextIntlClientProvider>
  );
}
